import React from 'react';
interface FooterProps {
  onNavigate?: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('terms');
    }
  };
  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('privacy-policy');
    }
  };
  const handleCookieClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('cookie-policy');
    }
  };
  const handleCANoticeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('ca-notice');
    }
  };
  const handleMatchCollegesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('request-information');
    }
  };
  return <footer className="bg-gray-50 border-t border-gray-200 py-12" data-id="element-125">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-127">
          <div className="col-span-1 md:col-span-2" data-id="element-128">
            <span className="text-xl font-bold text-gray-900 tracking-tight mb-4 block" data-id="element-129">
              FindOnlineDegrees
            </span>
            <p className="text-sm text-gray-500 leading-relaxed max-w-md" data-id="element-130">
              We help students find the right educational path by comparing top
              accredited online degree programs. Our mission is to make higher
              education more accessible and transparent.
            </p>
          </div>
          <div data-id="element-131">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-132">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-133">
              <li data-id="element-134">
                <button onClick={e => {
                e.preventDefault();
                if (onNavigate) onNavigate('colleges');
              }} className="hover:text-[#3b82f6] text-left" data-id="element-135">
                  Colleges
                </button>
              </li>
              <li data-id="element-136">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-137">
                  About Us
                </a>
              </li>
              <li data-id="element-138">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-139">
                  Contact
                </a>
              </li>
              <li data-id="element-140">
                <button onClick={handlePrivacyClick} className="hover:text-[#3b82f6] text-left" data-id="element-141">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-142">
                <button onClick={handleTermsClick} className="hover:text-[#3b82f6] text-left" data-id="element-143">
                  Terms & Conditions
                </button>
              </li>
              <li data-id="element-144">
                <button onClick={handleCookieClick} className="hover:text-[#3b82f6] text-left" data-id="element-145">
                  Cookie Policy
                </button>
              </li>
              <li data-id="element-146">
                <button onClick={handleCANoticeClick} className="hover:text-[#3b82f6] text-left" data-id="element-147">
                  CA Notice at Collection
                </button>
              </li>
            </ul>
          </div>
          <div data-id="element-148">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-149">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-150">
              <li data-id="element-151">
                <button onClick={e => {
                e.preventDefault();
                if (onNavigate) onNavigate('compare');
              }} className="hover:text-[#3b82f6] text-left" data-id="element-152">
                  Compare Schools
                </button>
              </li>
              <li data-id="element-153">
                <button onClick={e => {
                e.preventDefault();
                if (onNavigate) onNavigate('articles');
              }} className="hover:text-[#3b82f6] text-left" data-id="element-154">
                  Articles
                </button>
              </li>
              <li data-id="element-155">
                <button onClick={handleMatchCollegesClick} className="hover:text-[#3b82f6] text-left" data-id="element-156">
                  Match to Colleges
                </button>
              </li>
              <li data-id="element-157">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-158">
                  Financial Aid Guide
                </a>
              </li>
              <li data-id="element-159">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-160">
                  Accreditation Explained
                </a>
              </li>
              <li data-id="element-161">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-162">
                  Career Outlooks
                </a>
              </li>
              <li data-id="element-163">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-164">
                  Student Reviews
                </a>
              </li>
              <li data-id="element-165">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-166">
                  Area of Study
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8" data-id="element-167">
          <p className="text-xs text-gray-400 text-center mb-4" data-id="element-168">
            Advertising Disclosure: This website is an independent,
            advertising-supported comparison service. The offers that appear on
            this site are from companies from which we receive compensation.
            This compensation may impact how and where products appear on this
            site (including, for example, the order in which they appear). We do
            not include all available products or offers.
          </p>
          <p className="text-sm text-gray-500 text-center" data-id="element-169">
            &copy; {currentYear} FindOnlineDegrees. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}